export default "__VITE_ASSET__6a642ead__"